<!--Table-->
<div class="table-main-body">
	<p-table
		#mydt
		[value]="lstPerson"
		[loading]="loading"
		[paginator]="true"
		[(rows)]="pagerows"
		[(first)]="pagefirst"
		[showCurrentPageReport]="true"
		[resizableColumns]="false"
		sortMode="multiple"
		styleClass="p-datatable-striped"
		selectionMode="multiple"
		[(selection)]="SelectedPersons"
		dataKey="PersonID"
		(onFilter)="onHandleFilter($event)"
		(onSort)="onHandleSort($event)"
		(onRowSelect)="onRowSelect($event)"
		(onRowUnselect)="onRowUnselect($event)"
		currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
		[rowsPerPageOptions]="[5, 10, 25, 50]"
	>
		<!--Headers-->
		<ng-template pTemplate="header">
			<!--Filter or Select from Dropdown-->
			<tr>
				<th></th>

				<!--INSERT CUSTOM FILTERS HERE-->

				<!--StudentID-->
				<th>
					<p-columnFilter type="text" field="StaffID" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--FirstName-->
				<th>
					<p-columnFilter type="text" field="FirstName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--LastName-->
				<th>
					<p-columnFilter type="text" field="LastName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--SchoolFullName-->
				<th>
					<p-columnFilter type="text" field="SchoolFullName" matchMode="contains" [showMenu]="true"></p-columnFilter>
				</th>

				<!--PersonTypeDesc-->
				<th>
					<p-columnFilter field="PersonTypeDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterPersonTypeDesc
								[ngModel]="value"
								[options]="lstPersonTypeDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--StaffTitle-->
				<th>
					<p-columnFilter field="StaffTitle" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterStaffTitle
								[ngModel]="value"
								[options]="lstStaffTitle"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>

				<!--Email-->
				<th>
					<p-columnFilter type="text" field="EmailDesc" matchMode="contains" [showMenu]="true"></p-columnFilter>
					<!-- <p-columnFilter field="HasEmailDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown #filterHasEmailDesc [ngModel]="value" [options]="lstHasEmailDesc" (onChange)="filter($event.value)"
								placeholder="Any" [showClear]="true">
								<ng-template let-value pTemplate="item">
									<span>{{value}}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter> -->
				</th>

				<!--ActiveDesc-->
				<th>
					<p-columnFilter field="ActiveDesc" matchMode="equals" [showMenu]="false">
						<ng-template pTemplate="filter" let-value let-filter="filterCallback">
							<p-dropdown
								#filterActiveDesc
								[ngModel]="value"
								[options]="lstActiveDesc"
								(onChange)="filter($event.value)"
								placeholder="Any"
								[showClear]="true"
							>
								<ng-template let-value pTemplate="item">
									<span>{{ value }}</span>
								</ng-template>
							</p-dropdown>
						</ng-template>
					</p-columnFilter>
				</th>
			</tr>

			<!--Column Names-->
			<tr style="height: 4rem">
				<th>
					<p-tableHeaderCheckbox></p-tableHeaderCheckbox>
				</th>

				<!--INSERT CUSTOM COLUMNS HERE-->
				<th pSortableColumn="StaffID">Staff ID<p-sortIcon field="StaffID"></p-sortIcon></th>
				<th pSortableColumn="FirstName">First Name<p-sortIcon field="FirstName"></p-sortIcon></th>
				<th pSortableColumn="LastName">Last Name<p-sortIcon field="LastName"></p-sortIcon></th>
				<th pSortableColumn="SchoolFullName">School<p-sortIcon field="SchoolFullName"></p-sortIcon></th>
				<th pSortableColumn="PersonTypeDesc">Person Type<p-sortIcon field="PersonTypeDesc"></p-sortIcon></th>
				<th pSortableColumn="StaffTitle">Staff Title<p-sortIcon field="StaffTitle"></p-sortIcon></th>
				<th pSortableColumn="EmailDesc">Email on Record<p-sortIcon field="EmailDesc"></p-sortIcon></th>
				<th pSortableColumn="ActiveDesc">Active<p-sortIcon field="ActiveDesc"></p-sortIcon></th>
			</tr>
		</ng-template>

		<!--Data-->
		<ng-template pTemplate="body" let-Person>
			<tr [pSelectableRow]="Person">
				<td>
					<p-tableCheckbox [disabled]="loading == true" [pSelectableRow]="Person" [value]="Person"></p-tableCheckbox>
				</td>

				<td *ngFor="let col of cols" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person[col.field] }}
				</td>

				<td [style.color]="Person.Active == true ? 'Black' : 'Red'" style="font-weight: bold; text-overflow: ellipsis; word-break: break-word">
					{{ Person.ActiveDesc }}
				</td>
			</tr>
		</ng-template>
	</p-table>
</div>

<div class="Buttons">
	<button class="btn btn-primary" (click)="onAddToList()">Add to Email List</button>
</div>
